/*
  PawsLife Suchergebnisseite - Auswertung
  ---------------------------------------
  Meldet ausschliesslich in den dataLayer; ob daraus ein GA4-Treffer wird,
  entscheidet der Google Tag Manager (inklusive Consent Mode).

  Bewusst NICHT ueber paws-insights.js: dessen Basisblock haengt an jedem
  Ereignis Konfigurator-Felder (configurator, ab_variant, product_handle).
  Suchereignisse wuerden die Konfigurator-Berichte damit verwaessern.
  Hier gilt deshalb: eigener, minimaler Datensatz, bestehende Ereignisse
  bleiben unangetastet.
*/
(function () {
  'use strict';

  var quelle = document.querySelector('script[type="application/json"][data-paws-suche-daten]');
  if (!quelle) return;

  var daten = {};
  try {
    daten = JSON.parse(quelle.textContent) || {};
  } catch (e) {
    return;
  }
  if (daten.tracking === false) return;

  window.dataLayer = window.dataLayer || [];

  function kuerzen(wert) {
    return String(wert == null ? '' : wert).trim().slice(0, 100);
  }

  function melden(name, extra) {
    try {
      var satz = {
        event: name,
        search_term: kuerzen(daten.begriff),
        search_results_count: typeof daten.anzahl === 'number' ? daten.anzahl : null,
        search_page: daten.seite || 1
      };
      if (extra) {
        for (var k in extra) {
          if (Object.prototype.hasOwnProperty.call(extra, k)) satz[k] = extra[k];
        }
      }
      window.dataLayer.push(satz);
    } catch (e) {
      /* Auswertung darf die Suche niemals stoppen. */
    }
  }

  melden('view_search_results');
  if (!daten.anzahl) melden('search_no_results');

  // Oeffnet jemand die Suche direkt auf der Ergebnisseite, ist der erste
  // Begriff nachweislich danebengegangen - genau das soll im Bericht stehen.
  // Der neue Begriff kommt danach mit view_search_results der Folgeseite.
  var leiste = document.querySelector('.paws-such-kopf__leiste [data-paws-such-feld]');
  if (leiste) {
    leiste.addEventListener('click', function () {
      melden('search_refine');
    });
  }

  document.addEventListener('click', function (ereignis) {
    var ziel = ereignis.target.closest('[data-paws-such-vorschlag], [data-paws-kategorie][data-paws-quelle="ergebnisse"]');
    if (!ziel) return;

    if (ziel.hasAttribute('data-paws-such-vorschlag')) {
      melden('search_suggestion_click', { search_suggestion: kuerzen(ziel.getAttribute('data-paws-such-vorschlag')) });
    } else {
      melden('search_category_click', { search_category: kuerzen(ziel.getAttribute('data-paws-kategorie')) });
    }
  });
})();
